import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";

var _types$SET_OPTIONS$ty;

import reduce from 'lodash/reduce';
import * as types from './types';
import encodeCustomizable from '~/helpers/configurator-helper';
export default (_types$SET_OPTIONS$ty = {}, _defineProperty(_types$SET_OPTIONS$ty, types.SET_OPTIONS, function (state, payload) {
  var currentState = state;
  currentState.options = payload;
}), _defineProperty(_types$SET_OPTIONS$ty, types.SET_DEFAULT_CUSTOMIZABLE, function (state, payload) {
  var currentState = state;
  var model = payload.model.substring(0, 5);
  var customizable = reduce(payload.options, function (acc, option) {
    var item = option.items.find(function (o) {
      return o.selected;
    });

    if (item.subItems) {
      var subItem = item.subItems.find(function (e) {
        return e.selected;
      });
      acc[subItem.type] = subItem;
    }

    if (item) {
      acc[option.name] = item;
    }

    return acc;
  }, {});
  currentState.model = model;
  currentState.customizable = customizable;
  currentState.encodedCustomizable = encodeCustomizable(model, customizable);
  currentState.price = payload.price;
  currentState.information = payload.information;
}), _defineProperty(_types$SET_OPTIONS$ty, types.SET_SELECTED_OPTION, function (state, payload) {
  var currentState = state;
  currentState.selectedOption = payload;
}), _defineProperty(_types$SET_OPTIONS$ty, types.RESTORE_CUSTOMIZABLE, function (state) {
  var currentState = state;
  currentState.encodedCustomizable = currentState.oldCustomizable;
}), _defineProperty(_types$SET_OPTIONS$ty, types.SET_CONFIGURATOR, function (state, payload) {
  var currentState = state;

  if (payload) {
    currentState.oldCustomizable = currentState.encodedCustomizable;
  }

  currentState.configurator = payload;
}), _defineProperty(_types$SET_OPTIONS$ty, types.SELECT_OPTION_ITEM, function (state, payload) {
  var currentState = state;
  currentState.customizable[payload.option.name] = payload.item;
  currentState.encodedCustomizable = encodeCustomizable(currentState.model, currentState.customizable);
}), _defineProperty(_types$SET_OPTIONS$ty, types.SELECT_OPTION_ITEM_NESTED, function (state, payload) {
  var currentState = state;
  currentState.customizable[payload.option.name] = payload.item;

  var _payload$item$subItem = _slicedToArray(payload.item.subItems, 1);

  currentState.customizable.functionality = _payload$item$subItem[0];
  currentState.encodedCustomizable = encodeCustomizable(currentState.model, currentState.customizable);
}), _types$SET_OPTIONS$ty);